export default __webpack_public_path__ + "static/media/n20@2x.3ba584f1.png";